export { BrowseMaterialTabBar } from "#browse-material-tab-bar";
